export class TalepTur {

  id: number;
  isim: string;
  isDuzenlenebilir: boolean;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
